import React from 'react'
import cx from 'classnames'

// import { renderModules, renderTags } from '@/utls.js'
import Image from '@/image.js'
import PageLink from '@/link.js'
import { Arrow } from '@/svgs.js'
import META from '@/meta.js'
import Slideshow from '@/modules/slideshow.js'
import Footer from '@/footer.js'
import ComingSoon from '@/modules/comingSoon.js'

const Brand = ({ transitionStatus, entry, exit, pageContext }) => {
  const {
    brandPoints,
    brandImages,
    description,
    instagram,
    website,
    title
  } = pageContext.data
  const {
    data
  } = pageContext
  const metaData = {
    title: data.metaInfo ? data.metaInfo.metaTitle || `${data.title} - re:store` : `${data.title} - re:store`,
    keywords: data.metaInfo ? data.metaInfo.keywords || '' : '',
    description: data.metaInfo ? data.metaInfo.description || data.description : data.description,
    url: `/brands/${data.slug.current}`,
    image: data.image,
    ogTitle: data.metaInfo ? data.metaInfo.title || `${data.title} - re:store` : `${data.title} - re:store`,
    ogDescription: data.metaInfo ? data.metaInfo.openGraphDescription || data.description : data.description,
    ogImage: data.metaInfo ? data.metaInfo.openImage || data.image : data.image,
    twitterImage: data.metaInfo ? data.metaInfo.twitterImage || data.image : data.image,
    twitterTitle: data.metaInfo ? data.metaInfo.twitterTitle || `${data.title} - re:store` : `${data.title} - re:store`,
    twitterDescription: data.metaInfo ? data.metaInfo.twitterDescription || data.description : data.description
  }
  return (
    <div className={cx('animate__page', transitionStatus)}>
      <META metaData={metaData} />
      <div className='nav--spacer' />
      <div className='container--xl ma p1 f fw jcb ais brand__wrapper'>
        <div className='brand__data x'>
          <PageLink to='/whats-in-store' className='caps medium s14 mb1 block'>Back</PageLink>
          <h1 className='m0 h2 p0'>{title}</h1>
          <p className='s18'>{description}</p>
          <div className='brand__slideshow mobile mt15 x z1'>
            <Slideshow images={brandImages} />
          </div>
          <div>
            <h5 className='caps medium mb05'>Brand Points</h5>
            {brandPoints && brandPoints.map(point => (
              <div key={point._key} className='brand__point rel bcw mb1 f fw jcb aic'>
                <div className='brand__point-image f jcc aic x p15'>
                  <Image width={300} imageId={point.sticker.imageId} />
                </div>
                <div className='x brand__point-text'>
                  <p className='p1 s16'>{point.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className='f jcs aic'>
            {website && (<a href={website} target='_blank' rel='noopener noreferrer' className='mr15 arrow__link f aic jcs pr1'>Website <Arrow className='ml1' /></a>)}
            {instagram && (<a href={`https://instagram.com/${instagram}`} rel='noopener noreferrer' className='arrow__link f aic jcs' target='_blank'>Instagram <Arrow className='ml1' /></a>)}
          </div>
        </div>
        <div className='brand__slideshow desktop x z1'>
          <Slideshow images={brandImages} />
        </div>
      </div>

      <ComingSoon />
      <Footer />
    </div>
  )
}

export default Brand